import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine, SectionLabel } from "./Reveal";
import { SERVICES } from "../data/site";

export const Services = ({ onBook }) => (
  <section
      id="services"
      data-testid="services-pricing-section"
    className="relative bg-[#0a0d12] py-24 lg:py-36"
  >
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <SectionLabel testId="services-label">
            Chapter 03 · The Menu
          </SectionLabel>
          <h2 className="mt-7 font-cond text-4xl font-extrabold uppercase leading-[0.92] sm:text-5xl lg:text-6xl">
            <MaskLine>Full service.</MaskLine>
            <MaskLine delay={0.1} className="brass-text">
              Fair price. No games.
            </MaskLine>
          </h2>
        </div>
        <Reveal delay={0.15}>
          <button
            type="button"
            onClick={onBook}
            data-testid="services-book-button"
            className="sheen shrink-0 bg-[#c5a059] px-7 py-4 font-cond text-[13px] font-bold uppercase tracking-[0.2em] text-[#0a0d12] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d8b46b]"
          >
            <span className="sheen-bar" />
            Reserve a chair
          </button>
        </Reveal>
      </div>

      <div className="mt-14 border-t border-white/[0.09]">
        {SERVICES.map((s, i) => (
          <Reveal key={s.no} delay={Math.min(i * 0.05, 0.3)}>
            <button
              type="button"
              onClick={onBook}
              data-testid={`service-row-${s.no}`}
              className="group relative grid w-full grid-cols-[auto_1fr_auto] items-center gap-5 border-b border-white/[0.09] px-1 py-7 text-left transition-colors duration-500 hover:bg-white/[0.022] sm:gap-8 sm:px-4"
            >
              <span className="font-display text-xs text-[#c5a059]/60 transition-colors group-hover:text-[#d8b46b]">
                {s.no}
              </span>

              <div className="min-w-0">
                <div className="flex flex-wrap items-baseline gap-x-4">
                  <h3 className="font-cond text-2xl font-bold uppercase tracking-wide text-[#f0e9dc] transition-transform duration-500 group-hover:translate-x-1.5 sm:text-3xl">
                    {s.name}
                  </h3>
                  <span className="font-cond text-[11px] uppercase tracking-[0.2em] text-slate-400">
                    {s.time}
                  </span>
                  {s.addon && (
                    <span className="border border-[#c5a059]/30 bg-[#c5a059]/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-[#e2cf9e]">
                      {s.addon}
                    </span>
                  )}
                </div>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-500 transition-colors duration-500 group-hover:text-slate-400">
                  {s.desc}
                </p>
              </div>

              <div className="flex items-center gap-3">
                <span className="text-right font-cond text-xl font-extrabold leading-none text-[#c5a059] sm:text-3xl">
                  {s.price}
                </span>
                <ArrowUpRight
                  size={18}
                  className="hidden shrink-0 text-slate-400 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#d8b46b] sm:block"
                />
              </div>
            </button>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-7 text-xs uppercase tracking-[0.18em] text-slate-400">
          Every guest gets a complimentary drink on the house · Walk-ins accepted
          at both shops
        </p>
      </Reveal>
    </div>
  </section>
);
